import { Component } from '@theme/component';
import Splide from '@theme/splide';

export class CsClientSlider extends Component {
  connectedCallback() {
    super.connectedCallback();
    if (this._splideInit) return;
    this._splideInit = true;

    const init = () => {
      const el = this.querySelector('.splide');
      if (!el) return;

      const splide = new Splide(el, {
        gap: 14,
        pagination: false,
        arrows: false,
        fixedWidth: '420px',
        perMove: 1,
        drag: true,
        start: 0,
        breakpoints: {
          480: {
            fixedWidth: '82vw',
          },
          768: {
            fixedWidth: '360px',
          },
        },
      });

      splide.mount();
    };

    const run = () => requestAnimationFrame(() => requestAnimationFrame(init));

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run, { once: true });
    } else {
      run();
    }
  }
}

if (!customElements.get('cs-client-slider')) customElements.define('cs-client-slider', CsClientSlider);
